import { Box, Grid, Typography, useTheme } from "@mui/material";
import {
    EnhancedButtonPrimeReact,
    EnhancedButtonPrimeReactSeverity,
    EnhancedCheckboxRHF,
    EnhancedDropDownRHFWithLabel,
    EnhancedIOSSwitchRHF,
    EnhancedIOSSwitchRHFWithLabel,
    LabelPosition,
    PhoneNumberRHF,
    RHookFormDatePicker,
    RHookFormPasswordFieldWithLabel,
    RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { Dialog } from "primereact/dialog";
import { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { Button } from "primereact/button";
import TaxSlipsTermsAndConditions from "../../../../TaxSlipsTermsAndCondition/TaxSlipsTermsAndConditions";

interface ITaxSlipsInfoSetupFieldsPanel {
    ActivateTaxSlipsAddOnClickedHandler: () => void
    formMethods: any
}

export const TaxSlipsInfoSetupFieldsPanel: FC<
    ITaxSlipsInfoSetupFieldsPanel
> = ({ ActivateTaxSlipsAddOnClickedHandler, formMethods }) => {
    const theme = useTheme();
    const [visibleTermsAndConditions, setVisibleTermsAndConditions] =
        useState(false);

    const footerContent = (
        <div>
            <Button
                label="Ok"
                icon="pi pi-check"
                onClick={() => {
                    setVisibleTermsAndConditions(false);
                }}
                size="small"
            />
        </div>
    );
    const agreeTermsAndConditionsValue = formMethods.watch("agreeTermsAndConditions");

    return (
        <>
            <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                columnSpacing={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <Typography sx={{ fontSize: "1rem", fontWeight: "600", paddingBottom: "5px" }}>
                        Activate TaxSlips
                    </Typography>
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ paddingBottom: "1rem" }}>
                        <span style={{ fontSize: "0.775rem" }}>
                            To activate TaxSlips add-on:
                        </span><br />
                        <span style={{ fontSize: "0.775rem" }}>
                            &nbsp;&nbsp;&nbsp;&nbsp;- Select year,
                        </span><br />
                        <span style={{ fontSize: "0.775rem" }}>
                            &nbsp;&nbsp;&nbsp;&nbsp;- Enter your SimplePay password
                        </span><br />
                        <span style={{ fontSize: "0.775rem" }}>
                            &nbsp;&nbsp;&nbsp;&nbsp;- Select all/any companies associated with your account<br /> &nbsp;&nbsp;&nbsp;&nbsp; to connect to TaxSlips
                        </span><br />
                        <span style={{ fontSize: "0.775rem" }}>
                            &nbsp;&nbsp;&nbsp;&nbsp;- Activate TaxSlips Add-On
                        </span><br />
                        <span style={{ fontSize: "0.775rem" }}>
                            &nbsp;&nbsp;&nbsp;&nbsp;- After activation, you can export data to TaxSlips for selected year
                        </span><br />

                    </Grid>

                    <RHookFormTextFieldWithLabel
                        label="Phone Number"
                        id="phoneNumber"
                        testId={`phone-number`}
                        labelPosition={LabelPosition.Top}
                    />
                    <RHookFormPasswordFieldWithLabel
                        id="simplePayPassword"
                        testId={`simplepay-password`}
                        label="SimplePay Password"
                        labelPosition={LabelPosition.Top}
                    />
                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} >
                        <div style={{
                            display: "flex",
                            gap: "1rem",
                            alignContent: "center",
                            justifyContent: "start",
                            alignItems: "start",
                        }}>
                            <Typography
                                sx={{
                                    padding: "4px 0px",
                                    cursor: "pointer",
                                    "&.MuiTypography-root:hover": { color: "#066BB3" },
                                    color: "#018ef3",
                                    fontSize: "0.875rem",
                                }}
                                variant="body1"
                                onClick={() => setVisibleTermsAndConditions(true)}
                            >
                                Terms & Conditions{" "}
                            </Typography>
                            <EnhancedIOSSwitchRHF
                                name="agreeTermsAndConditions"
                                checked={false}
                                testId="agreeTermsAndConditions"
                            // onSelectionChangeHandler={onSelectionChange}
                            />

                            <Dialog
                            
                                header={<div
												style={{
													display: "flex",
													justifyContent: "start",
													alignItems: "start",
													height: "40px",
													width: "100%",
													
												}}
											>
												<img
													src={"https://www.simplepay.ca/canada_payroll//resources/images/taxslips_logo.jpg"}
													alt="loading"
													style={{
														maxWidth: "180px",
														maxHeight: "100%",
														objectFit: "contain",
														cursor: "pointer",
													}}
												/>

											</div>}
                                footer={footerContent}
                                visible={visibleTermsAndConditions}
                                style={{ width: "50vw" }}
                                onHide={() => setVisibleTermsAndConditions(false)}
                            >
                                <TaxSlipsTermsAndConditions />
                            </Dialog>
                        </div>
                        <EnhancedButtonPrimeReact
                            label="Activate TaxSlips Add-On"
                            raised
                            severity={EnhancedButtonPrimeReactSeverity.Success}
                            onClickHandler={ActivateTaxSlipsAddOnClickedHandler}
                            disabled={!agreeTermsAndConditionsValue}
                        />
                    </Grid>
                </Grid>

            </Grid>
        </>
    );
}
